<template>
  <div class="max-w-5xl mx-auto pb-5">
    <h2 class="text-4xl max-md:text-center text-white">Fidati aiutanti di<br/>
      Babbo Natale dal 2017</h2>
    <section class="p-3 prose">
      <article class="py-5">
        <h3 class="text-xl text-white pb-5">Chi è Italia non profit?</h3>
        <p class="text-neutral-300">
          Italianonprofit.it è la più grande piattaforma digitale dedicata al non profit in Italia.Fornisce a
          fondazioni,
          aziende, enti e cittadini strumenti digitali gratuiti per l’orientamento e la conoscenza del
          Settore.<br /><br />
          Vuoi scoprire qualcosa di più su ciò che facciamo? Inizia da qui.
        </p>
      </article>
      <article class="py-5">
        <img src="~/assets/images/icons/icona_cane.png" alt="sei un'azienda?" class="py-5 mx-auto">
        <h3 class="text-xl text-white pb-5">Perché un Market Solidale di Natale?</h3>
        <p>
          Che cosa regalo questo Natale? È il vero mantra di ogni stagione natalizia. Quante volte ci siamo ritrovati a
          impazzire alla ricerca dell’idea regalo perfetta, per poi impazzire di nuovo nel realizzarla per
          tempo?<br /><br />
          Il Market Solidale di Natale nasce per rispondere a questa esigenza: aggregare tutte le offerte del non profit
          italiano in
          un unico posto, facilitare la conoscenza dei cittadini e avvicinare il Terzo Settore e renderlo più
          accessibile.
          Velocità e semplicità, senza dimenticare il lato più emozionale del non profit: le persone e le loro
          motivazioni.<br /><br />
          Non ci credi? Mettilo alla prova!
        </p>
      </article>
    </section>

    <UiDiscoverMore />
  </div>
</template>

<script setup lang="ts">
import { definePageMeta } from "#imports";

const showActions = inject('showActions')
// Cambia il valore per questa pagina
showActions.value = false

definePageMeta({
  layout: 'dark'
})
</script>